import Component from './LocationForm.container';

export default Component;
